import { formatDistanceToNowStrict } from 'date-fns';

const compact = new Intl.NumberFormat('en', { notation: 'compact', maximumFractionDigits: 1 });
const plain = new Intl.NumberFormat('en');

export function metric(value: number): string {
  return value >= 10_000 ? compact.format(value) : plain.format(value);
}

export function count(value: number): string {
  return plain.format(value);
}

/** "3m", "5h", "2d" — deliberately terse; the console is dense. */
export function relative(iso: string): string {
  const distance = formatDistanceToNowStrict(new Date(iso), { addSuffix: false });
  const [amount, unit] = distance.split(' ');
  if (!amount || !unit) return distance;
  const short: Record<string, string> = {
    second: 's',
    seconds: 's',
    minute: 'm',
    minutes: 'm',
    hour: 'h',
    hours: 'h',
    day: 'd',
    days: 'd',
    month: 'mo',
    months: 'mo',
    year: 'y',
    years: 'y',
  };
  return `${amount}${short[unit] ?? unit}`;
}

/** Absolute UTC timestamp — the reference clock everywhere in the UI. */
export function utcStamp(iso: string | Date): string {
  const date = typeof iso === 'string' ? new Date(iso) : iso;
  return date.toISOString().replace('T', ' ').slice(0, 19) + 'Z';
}

export function utcClock(date: Date): string {
  return date.toISOString().slice(11, 19);
}

export function utcDate(date: Date): string {
  return date.toISOString().slice(0, 10);
}
